import { css } from 'styled-components';
import { ButtonStyle } from '../../../../components/Button/styles';
import {
  HeadingLink,
  SecondaryLink,
  StyledImage,
} from '../../../../components/ProductCard/ProductCard/styles';
import spacing from '../../../../helpers/spacing';

export default css`
  ${HeadingLink} {
    width: 100%;
  }

  ${StyledImage} {
    width: 100%;
    object-fit: contain;
  }

  ${SecondaryLink} {
    text-decoration: underline;
    text-align: center;
    margin-top: ${spacing(4)};
  }

  ${ButtonStyle} {
    min-height: ${spacing(8)};
    height: fit-content;

    & > span {
      min-height: 64px;
    }
  }
`;
